<template>
    <div id="invoiceLayout" class="d-none d-md-block" >
        <div class="row" style="padding: 1px;">

            <!--Section de gauche-->
            <div class="cols-12 invoiceWrapper" :xs="pSize.left.xs" :sm="pSize.left.xs" :md="pSize.left.xs" :lg="pSize.left.xs" :xl="pSize.left.xs">
                <!-- Entete de la page-->
                <div>
                    <div class="d-flex justify-content-between">
                        <div class="px-1 width-left bg-color">
                            <s-button 
                                name="btnFullScreen"
                                id="btnFullScreen" 
                                @action="toogle"
                                :iconConditionVar="showLeftPanel"
                                iconName1="arrow-bar-left"
                                iconName2="arrow-bar-right"
                                color="gray"
                                :size="getAllSize.buttonItemList"
                                style="margin: 2px;">
                            </s-button>
                        </div>
                        <div class="p-1 bg-secondary-color" style="width:100%;border:0px solid gray;color:white;">
                            Note : Ici on place la note du client ... 
                        </div>
                        <div class="pl-3 width-15 bg-color text-md-end d-flex justify-content-end align-items-center">
                            <span> Solde du compte : <span v-text="parseFloat(invoice.totalPrice).toFixed(2)+'$'"></span></span>
                            <s-button 
                                name="btnFullScreen"
                                id="btnFullScreen" 
                                @action="toogleRight"
                                :iconConditionVar="showRightPanel"
                                iconName1="box-arrow-right"
                                iconName2="box-arrow-left"
                                color="gray"
                                :size="getAllSize.buttonItemList"
                                class="pl-4 pr-2"
                                style="margin: 0px;">
                            </s-button>
                        </div>
                    </div>
                </div>

                <div class="float-none height-100 position-relative" style="border:0px solid rgb(205, 102, 13);">
                    <Transition name="slide-fade">
                        <!-- Panneau latéral gauche -->
                        <div v-show="showLeftPanel" class="d-flex fixed-top height-100  position-absolute position-topRight panelColor" 
                            :class="{'width-left': showLeftPanel, 'width-0': !showLeftPanel}"
                        >
                            <div class="width-100 zone-topLeft overflow-auto" style="border:0px dashed blue;" ref="leftPanel">
                                <!-- <button @click="scrollToElement">scroll to last</button> -->

                                <b-container class="submenu">
                                    <b-row>
                                        <b-col @click="activeTab = 1" class="cursorPoint" :class="{'active-submenu': activeTab == '1', 'submenu-item': activeTab != '1'}" >
                                            Facturation
                                        </b-col>
                                        <b-col @click="activeTab = 2" class="cursorPoint" :class="{'active-submenu': activeTab == '2', 'submenu-item': activeTab != '2'}">
                                            Livraison
                                        </b-col>
                                    </b-row>
                                </b-container>

                                <b-container class="">
                                    <b-row v-show="activeTab == '1'">
                                        <b-col cols="12">
                                            <b-form-input size="sm" 
                                                class="my-2"
                                                autocomplete="off" 
                                                ref="shippingSearch" 
                                                name="search" 
                                                type="text" :placeholder="$t('g_Recherche')" 
                                                v-model="searchTxt" 
                                                v-on:keyup="showlist">
                                            </b-form-input>

                                            <div v-if="isloading" class="d-flex align-items-center">
                                                <strong class="mx-4">Loading...</strong>
                                                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                            </div>

                                            <b-list-group>
                                                    <b-list-group-item class="cursorPoint btnStyle text-sm"  
                                                        v-for="(client, index) in clientList" :key="client.id" @click="selectShippingAddress(client)"
                                                        :ref="index === 0 ? 'first' : undefined"
                                                        >
                                                        <strong v-text="client.clientNumber" class="bg-gradient-primary text-black-50"></strong>
                                                        <address class="">
                                                            <strong v-text="client.clientName"></strong>
                                                            <span v-if="client.isParticular"><br>{{ $t('cc_Societe') }} : <span v-text="client.contact"></span>,</span>
                                                        </address>
                                                    </b-list-group-item>
                                            </b-list-group>

                                        </b-col>
                                    </b-row>

                                    <b-row v-show="activeTab == '2'">
                                        <b-col cols="12" >
                                            <b-form-input size="sm" 
                                                class="my-2"
                                                autocomplete="off" 
                                                ref="billingSearch" 
                                                name="search" 
                                                type="text" :placeholder="$t('g_Recherche')" 
                                                v-model="searchTxt" 
                                                v-on:keyup="showlist">
                                            </b-form-input>

                                            <div v-if="isloading" class="d-flex align-items-center">
                                                <strong class="mx-4">Loading...</strong>
                                                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                            </div>

                                            <b-list-group>
                                                    <b-list-group-item class="cursorPoint btnStyle text-sm" 
                                                        v-for="(client, index) in clientList" :key="client.id" @click="selectBillingAddress(client)"
                                                        :ref="index === 0 ? 'first' : undefined"
                                                        >
                                                        <strong v-text="client.clientNumber" class="bg-gradient-primary text-black-50"></strong>
                                                        <address class="">
                                                            <strong v-text="client.clientName"></strong>
                                                            <span v-if="client.isParticular"><br>{{ $t('cc_Societe') }} : <span v-text="client.contact"></span>,</span>
                                                        </address>
                                                    </b-list-group-item>
                                            </b-list-group>

                                        </b-col>
                                    </b-row>

                                    <div v-if="!isloading && clientList.length > 0"  class="d-flex align-items-center justify-content-center p-0">
                                        <b-button  :variant="getTheme.light" size="sm" @click="scrollToFirstElement">
                                            <b-icon icon="chevron-up" :variant="getTheme.primary" font-scale="1"></b-icon> Top
                                        </b-button>
                                    </div>

                                </b-container>
                            </div>
                        </div>
                    </Transition>


                    <div class="width-100 position-absolute position-topLeft max-height-90 height-88 overflow-auto" style="border:0px dashed red;">
                        <!-- Partie entière gauche de la page (70% de la largeur total et 100% de la hauteur )  -->
                        <div class="height-100 width-100 position-absolute position-topLeft " style="border:0px solid green"
                            :class="{'width-85': showRightPanel, 'width-100': !showRightPanel}"
                        >
                 
                            <div class="d-flex bd-highlight mb-0" style="border-bottom:1px solid grey;" >
                                <div class="p-0 w-100 bd-highlight">
                                    <invoiceHeader 
                                        :clientAddress.sync="shippingAddr" 
                                        :billingAddress.sync="billingAddr"  
                                        @openShipping="openShipping" 
                                        @openBilling="openBilling"
                                    />
                                </div>
                            </div> 

                            <div class="height-82 overflow-auto" style="border:0px dashed blue;">
                                <div class="d-flex flex-column-reverse bd-highlight overflow-auto">
                                    <div class="px-2 bd-highlight height-100 " style="border:0px dashed hotpink;">
                                        

                                        <b-container fluid class="position-absolute position-topRight width-100" >
                                            <div class="row">
                                                <div class="col-lg-8">
                                                    <b-row  class="nav-tabs">
                                                        <b-col @click="invoiceTab = 1" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '1', 'tab-item': invoiceTab != '1'}">
                                                            Services
                                                        </b-col>
                                                        <b-col @click="invoiceTab = 2" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '2', 'tab-item': invoiceTab != '2'}">
                                                            Inspections
                                                        </b-col>
                                                        <b-col @click="invoiceTab = 3" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '3', 'tab-item': invoiceTab != '3'}">
                                                            Activity
                                                        </b-col>
                                                        <b-col @click="invoiceTab = 4" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '4', 'tab-item': invoiceTab != '4'}">
                                                            Inspections
                                                        </b-col>
                                                        <b-col @click="invoiceTab = 5" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '5', 'tab-item': invoiceTab != '5'}">
                                                            Option #1
                                                        </b-col>

                                                        <b-col @click="invoiceTab = 6" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '6', 'tab-item': invoiceTab != '6'}">
                                                            Option #2
                                                        </b-col>
                                                        <b-col @click="invoiceTab = 7" class="cursorPoint text-nowrap" :class="{'active-tab': invoiceTab == '7', 'tab-item': invoiceTab != '7'}">
                                                            Option #3
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <div class="col-lg-4">
                                                    
                                                </div>
                                            </div>
                                            <div class="row height-75 pl-2" style="border:0px solid red;">
                                                <div class="content width-100 overflow-auto" style="border:0px solid green;">
                                                    <div v-show="invoiceTab == '1'" >
                                                        <!-- Contenu de l'onglet Services -->
                                                        <div class="p-0">
                                                            <invoiceDetail @onItemsChanged="itemsChanged"/>
                                                        </div>
                                                    </div>
                                                    <div v-show="invoiceTab == '2'">
                                                        Contenu de l'onglet Inspections
                                                        
                                                    </div>
                                                    <div v-show="invoiceTab == '3'" >
                                                        Contenu de l'onglet Activity
                                                    </div>
                                                    <div v-show="invoiceTab == '4'" >
                                                        Contenu de l'onglet Inspections
                                                    </div>
                                                    <div v-show="invoiceTab == '5'" >
                                                        Contenu de l'onglet Option #1
                                                    </div>
                                                    <div v-show="invoiceTab == '6'">
                                                        Contenu de l'onglet Option #2
                                                    </div>
                                                    <div v-show="invoiceTab == '7'">
                                                        Contenu de l'onglet Option #3
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </b-container>
                                         

                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>

                    <!-- Panneau latéral droit  (15% de la largeur total )-->
                    <div v-show="showRightPanel" class="height-100 position-absolute position-topRight width-15 panelColor" 
                        :class="{'width-15': showRightPanel, 'width-0': !showRightPanel}"
                    >
                        <div class="width-100 zone-topLeft p-2 d-flex justify-content-center flex-row flex-wrap overflow-auto justify-content-center align-items-lg-start align-items-sm-center align-items-md-center align-items-lg-center">
                            totalPrice : {{ parseFloat(invoice.totalPrice).toFixed(2)+'$'  }} <br/>
                        </div>
                    </div>

                </div>
            </div>
            <!--Fin section de gauche-->
        </div>
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import invoiceHeader from '@/components/invoice/invoiceHeader/invoiceHeader.vue'
import invoiceDetail from '@/components/invoice/invoiceDetail/invoiceDetail.vue'
import {dataService} from '@/services'


export default{
    name: "invoiceLayout",
    mixins:[mapGetter],
    components: {
        invoiceHeader,
        invoiceDetail
    },
    props: {
        showLeftPanel: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return{
            showRightPanel : true,
            activeTab : 1,
            invoiceTab: 1,
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            isloading : false,
            clientList : [],
            resultList: [],
            searchTxt : '',
            invoiceItems : [],
            shippingAddr : {
                id : 0,
                number : '',
                name: '',
                address1: '',
                city: '',
                zipcode: '',
                tel1: '',
            },
            billingAddr : {
                id : 0,
                number : '',
                name: '',
                address1: '',
                city: '',
                zipcode: '',
                tel1: '',
            },
            invoice : {
                shipTo : {},
                billTo : {},
                items : [],
                totalPrice : 0.00
            }

        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        toogle() {
            this.showLeftPanel = !this.showLeftPanel
            if(this.showLeftPanel) {
                this.showlist()
            }
        },
        toogleRight() {
            this.showRightPanel = !this.showRightPanel
        },
        showlist() {
            this.showLeftPanel = true
            this.isloading = true
            dataService.getClientAccountList()
            .then(response => {
                if(response.statusText == 'OK')
                {
                    let data = response.data.data;
                    let clientList = this.$CObj(data.client)

                    //Pour chaque client retourner le premier addresse
                    clientList = clientList.map(client => {
                        const firstAddrFound = client.addressList.find((addr) => addr.id > 0);
                        if(firstAddrFound) {
                            client.addressList = []
                            client.addressList.push(firstAddrFound)
                        }
                        return client
                    });

                    var items = clientList
                    const search = this.searchTxt.toLowerCase().trim();
                    if (!search) items = clientList;
                    else {
                        var filteredItems = clientList.filter(client => {
                            var values = Object.values(client)
                            if(JSON.stringify(values.toString().toLowerCase()).indexOf(search) > -1) {
                                return client
                            }
                        });
                        items = [...new Set(filteredItems)] 
                    }
                    this.clientList = items
                    this.isloading = false
                }
            })
            .catch(error =>{
                this.isloading = false
                console.log(error);
                alert(error);
            })
        },
        openShipping() {
            this.activeTab = 1
            this.showLeftPanel = true
            
            setTimeout(() =>{
                this.showlist()
            }, 500);

            this.$refs.shippingSearch.focus();
            this.$nextTick(() => {
                this.scrollToFirstElement()
            });

        },
        openBilling() {
            this.activeTab = 2
            this.showLeftPanel = true
            
            setTimeout(() =>{
                this.showlist()
            }, 500);

            this.$refs.billingSearch.focus();
            this.$nextTick(() => {
                this.scrollToFirstElement()
            });
        },
        closePanel() {
            this.showLeftPanel = false
        },
        selectShippingAddress(client) {
            this.searchTxt = ""
            const firstAddrFound = client.addressList.find((addr) => addr.id > 0);
            if(firstAddrFound) {
                client.addressList = []
                client.addressList.push(firstAddrFound)
            }

            this.closePanel()
            setTimeout(() =>{
                this.shippingAddr = this.$CObj(Object.assign(this.shippingAddr, { id: client.id, number: client.clientNumber ,name: client.clientName, address1: client.addressList[0].address1,city: client.addressList[0].city, zipcode: client.addressList[0].zipcode, tel1: client.addressList[0].tel1}))
                this.clientList = []
            }, 500);
        },
        selectBillingAddress(client) {
            this.searchTxt = ""
            const firstAddrFound = client.addressList.find((addr) => addr.id > 0);
            if(firstAddrFound) {
                client.addressList = []
                client.addressList.push(firstAddrFound)
            }

            this.closePanel()
            setTimeout(() =>{
                this.billingAddr = this.$CObj(Object.assign(this.billingAddr, { id: client.id, number: client.clientNumber ,name: client.clientName, address1: client.addressList[0].address1,city: client.addressList[0].city, zipcode: client.addressList[0].zipcode, tel1: client.addressList[0].tel1}))
                this.clientList = []
            }, 500);
        },
        itemsChanged(params) {
            let items  = params.items
            this.invoiceItems = items

            const totalPrice = this.$CObj(this.invoiceItems.map((item) => item.price).reduce((accumulator, currentPrice) => Number(accumulator) + Number(currentPrice), 0))
            const totalQty = this.$CObj(this.invoiceItems.map((item) => item.qty).reduce((accumulator1, currentQty) => Number(accumulator1) + Number(currentQty),0))
            
            Object.assign(this.invoice, {
                shipTo : this.$CObj(this.shippingAddr),
                billTo : this.$CObj(this.billingAddr),
                items : this.$CObj(this.invoiceItems),
                totalPrice : totalPrice,
                totalQty : totalQty
            })

            this.$emit('on-invoice', {invoice: this.invoice});
        },
        scrollToFirstElement() {
            const [el] = this.$refs.first;
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
                el.scrollTop({ top: 0, behavior: 'smooth' });
                el.scrollTop = 0
            }
        },
        
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        _isLeftPanel: {
            get: function() {return this.showLeftPanel},
            set: function(modifiedValue){this.$emit('update:showLeftPanel', modifiedValue)}
        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {

    },
//------------------------------------------------------------------------------------------------
    watch: {
        shippingAddr(newValue) {
            Object.assign(this.invoice, {
                shipTo : this.$CObj(newValue),
            })
            if(newValue.id == 0) {
                Object.assign(this.invoice, {
                    shipTo : {},
                })
            }
        },
        billingAddr(newValue) {
            Object.assign(this.invoice, {
                billTo : this.$CObj(newValue),
            })
            if(newValue.id == 0) {
                Object.assign(this.invoice, {
                    billTo : {},
                })
            }
        },
        //invoice(newValue) {
        //    this.$emit('on-invoice', {invoice: newValue});
        //}
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/views/invoice.scss';
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-out;
  opacity: 1;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 1;
}
</style>